import React from 'react';
import { Container, Row, Col, Button, } from 'react-bootstrap';

function Payment() {
  return (
    <Container fluid className="h-100 mt-4">
      <Row className="mb-3">
        <Col>月額プラン説明</Col>
      </Row>
      <Row className="mb-3">
        <Col>カード情報登録</Col>
      </Row>
      <Row>
        <Col className="w-50">
          <Button variant="primary">登録する</Button>
        </Col>
      </Row>
    </Container>
  );
}

export default Payment;
